import React, { useState } from "react";
import { Container } from "react-bootstrap";
import "./FeatureProducts.css";
import { Link } from "react-router-dom";
import { AiOutlineMinusCircle,AiOutlineEye } from "react-icons/ai";
import { BsSuitHeart,BsBagCheck } from "react-icons/bs";

const FeatureProducts = () => {
  const [showModal, setShowModal] = useState(false);
  const handleClose = () => setShowModal(false);
  const handleShow = () => setShowModal(true);
  return (
    <div className="features section-container">
      {/* quick view modal begin  */}
      {showModal && (
        <div>
          <div className="custom-modal-container">
            <div className="custom-modal-body p-5">
              <div className="position-absolute top-0 end-0 p-2">
                <AiOutlineMinusCircle className="fs-4 pointer" onClick={handleClose} />
              </div>
              Lorem ipsum dolor sit amet consectetur adipisicing elit. Nulla
              eveniet, asperiores vero unde doloribus tempora dignissimos
              assumenda consectetur aut recusandae delectus expedita. Corporis
              saepe quos voluptatibus commodi omnis neque obcaecati fugiat,
              nostrum consequuntur ad repellat, quaerat et? Sed assumenda rem
              iste! Dolorum natus nesciunt, iure possimus deleniti minus modi
              facere ipsa veniam officia unde quasi in voluptates, est numquam
              non consequatur fugit minima quo debitis voluptate quibusdam
              pariatur officiis mollitia. Ipsum officiis ad assumenda fugiat sit
              id fuga, doloribus illo magni animi corporis molestias provident
              cum, molestiae mollitia! Quo quasi eaque dolorem veniam quidem
              illum eum similique blanditiis voluptatum ab nobis, vel aliquid
              maiores nihil reprehenderit, adipisci sapiente eos quod deserunt!
              Quam facere magnam minima esse neque aperiam, laudantium voluptas
              delectus alias nam ipsam maxime nostrum reprehenderit asperiores
              magni omnis doloremque iste deserunt eaque quas soluta nulla
              expedita fugiat? Enim eligendi ipsa modi distinctio voluptas
              laudantium beatae autem magnam ratione.
            </div>
          </div>
        </div>
      )}
      {/* quick view modal end  */}
      <Container>
        <div className="section-heading text-center">
          <span>Explore Now</span>
          <h2>Featured Products</h2>
          <p>
            Lorem ipsum dolor sit amet consectetur, adipisicing elit. Sed odit
            atque aspernatur. <br /> Dolor id exercitation magtibus excepturi,
            repudiandae deserunt!
          </p>
        </div>
        <div className="row">
          <div className="col-6 col-md-6 col-lg-4 col-xl-3 py-2">
            <div className="most-view-card">
              <div className="most-view-card-img">
                <img
                  src={require("../../../images/features/feature4.png")}
                  alt=""
                  className="w-100 h-100"
                />
                <div className="details-button-group">
                  <Link to="products/5">
                    <button className="w-100 p-2 border-0 bg-transparent text-light">
                      Buy Now
                    </button>
                  </Link>
                </div>
                <div className="details-button-group2 pt-3">
                  <button className="border-0 profile-icon my-1 text-dark d-flex align-items-center justify-content-center">
                    <BsSuitHeart />
                  </button>
                  <button className="border-0 profile-icon my-1 text-dark d-flex align-items-center justify-content-center">
                    <AiOutlineEye onClick={handleShow} />
                  </button>
                  <button className="border-0 profile-icon my-1 text-dark d-flex align-items-center justify-content-center">
                    <BsBagCheck />
                  </button>
                </div>
              </div>
              <div className="most-view-card-text d-flex align-items-center justify-content-between text-center p-2">
                <h5 className="fw-light m-0">Mens Shirt</h5>
                <h5 className="fw-normal text-dark m-0">$12.99</h5>
              </div>
            </div>
          </div>
          <div className="col-6 col-md-6 col-lg-4 col-xl-3 py-2">
            <div className="most-view-card">
              <div className="most-view-card-img">
                <img
                  src={require("../../../images/features/feature2.png")}
                  alt=""
                  className="w-100 h-100"
                />
                <div className="details-button-group">
                  <Link to="products/5">
                    <button className="w-100 p-2 border-0 bg-transparent text-light">
                      Buy Now
                    </button>
                  </Link>
                </div>
                <div className="details-button-group2 pt-3">
                  <button className="border-0 profile-icon my-1 text-dark d-flex align-items-center justify-content-center">
                    <BsSuitHeart />
                  </button>
                  <button className="border-0 profile-icon my-1 text-dark d-flex align-items-center justify-content-center">
                    <AiOutlineEye onClick={handleShow} />
                  </button>
                  <button className="border-0 profile-icon my-1 text-dark d-flex align-items-center justify-content-center">
                    <BsBagCheck />
                  </button>
                </div>
              </div>
              <div className="most-view-card-text d-flex align-items-center justify-content-between text-center p-2">
                <h5 className="fw-light m-0">Mens Shirt</h5>
                <h5 className="fw-normal text-dark m-0">$12.99</h5>
              </div>
            </div>
          </div>
          <div className="col-6 col-md-6 col-lg-4 col-xl-3 py-2">
            <div className="most-view-card">
              <div className="most-view-card-img">
                <img
                  src={require("../../../images/features/feature5.png")}
                  alt=""
                  className="w-100 h-100"
                />
                <div className="details-button-group">
                  <Link to="products/5">
                    <button className="w-100 p-2 border-0 bg-transparent text-light">
                      Buy Now
                    </button>
                  </Link>
                </div>
                <div className="details-button-group2 pt-3">
                  <button className="border-0 profile-icon my-1 text-dark d-flex align-items-center justify-content-center">
                    <BsSuitHeart />
                  </button>
                  <button className="border-0 profile-icon my-1 text-dark d-flex align-items-center justify-content-center">
                    <AiOutlineEye onClick={handleShow} />
                  </button>
                  <button className="border-0 profile-icon my-1 text-dark d-flex align-items-center justify-content-center">
                    <BsBagCheck />
                  </button>
                </div>
              </div>
              <div className="most-view-card-text d-flex align-items-center justify-content-between text-center p-2">
                <h5 className="fw-light m-0">Mens Shirt</h5>
                <h5 className="fw-normal text-dark m-0">$12.99</h5>
              </div>
            </div>
          </div>
          <div className="col-6 col-md-6 col-lg-4 col-xl-3 py-2">
            <div className="most-view-card">
              <div className="most-view-card-img">
                <img
                  src={require("../../../images/features/feature6.png")}
                  alt=""
                  className="w-100 h-100"
                />
                <div className="details-button-group">
                  <Link to="products/5">
                    <button className="w-100 p-2 border-0 bg-transparent text-light">
                      Buy Now
                    </button>
                  </Link>
                </div>
                <div className="details-button-group2 pt-3">
                  <button className="border-0 profile-icon my-1 text-dark d-flex align-items-center justify-content-center">
                    <BsSuitHeart />
                  </button>
                  <button className="border-0 profile-icon my-1 text-dark d-flex align-items-center justify-content-center">
                    <AiOutlineEye onClick={handleShow} />
                  </button>
                  <button className="border-0 profile-icon my-1 text-dark d-flex align-items-center justify-content-center">
                    <BsBagCheck />
                  </button>
                </div>
              </div>
              <div className="most-view-card-text d-flex align-items-center justify-content-between text-center p-2">
                <h5 className="fw-light m-0">Mens Shirt</h5>
                <h5 className="fw-normal text-dark m-0">$12.99</h5>
              </div>
            </div>
          </div>
        </div>
      </Container>
    </div>
  );
};

export default FeatureProducts;
